const removeValueFromArray = (array: [string], valueToRemove: string) => (
  array.filter((arrayValue) => arrayValue !== valueToRemove)
);

export default removeValueFromArray;
